import { gql } from '@apollo/client'

export const GetViewUuidsForListNavigation = gql`
  query GetViewUuidsForListNavigationQuery($input: GetViewsInput!) {
    getViews(input: $input) {
      id
      uuid
    }
  }
`
